import React from 'react';
import PropTypes from 'prop-types';

function FormTextarea({
  label,
  id,
  value,
  onChange,
  onBlur,
  error,
  rows,
  className,
}) {
  return (
    <div className={className}>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700">
        {label}
      </label>
      <textarea
        id={id}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        rows={rows}
        className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
      />
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
}

FormTextarea.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  error: PropTypes.string,
  rows: PropTypes.number,
  className: PropTypes.string,
};

FormTextarea.defaultProps = {
  onBlur: () => {},
  error: '',
  rows: 3,
  className: '',
};

export default FormTextarea;
